import { useTranslation } from 'next-i18next';
import React, { useEffect } from 'react';
import { LoginDatos } from '@/objects/User';
import { cargarDatosUsuario } from '@/util/LocalStorageLoaded';
import { useServices } from '@/context/ServicesProvider';
import { GetMisTransaccionesBeseif } from '@/objects/Beseif';
import { AxiosResponse } from 'axios';
import { urlBeseifMisTransacciones } from '@/util/BaseURL';

function BeseifTransaciones() {

    const { beseifQueries } = useServices();


    const { t } = useTranslation();

    const [datosUsuario, setDatosUsuario] = React.useState<LoginDatos | null>();

    const [url_cargar, setUrlCargar] = React.useState<string>("");

    React.useEffect(() => {
        setDatosUsuario(cargarDatosUsuario()!);
    }, []);

    useEffect(() => {
        //Comprueba que has iniciado sesion
        if (datosUsuario != null) {
            //alert(JSON.stringify(datosUsuario));
            abrirCompraBeseif(datosUsuario);
        }
    }, [datosUsuario]);

    function abrirCompraBeseif(datosUsuario: LoginDatos) {

        // const objBeseif: PostBeseifObj = {
        //     id_user: Number(datosUsuario.id_user)
        // };

        const getProcesoBeseif: GetMisTransaccionesBeseif = {
            id_user: Number(datosUsuario.id_user),
            email_usuario: String(datosUsuario.email)
        };

        beseifQueries?.obtenerMisComprasBeseif(getProcesoBeseif).then((response: AxiosResponse<string>) => {
            if (response.status == 200) {
                const codigo = response.data;
                setUrlCargar(`${urlBeseifMisTransacciones}${codigo}`)
            }
        }
        ).catch((error: any) => {

        });
    }


    return (
        <section style={{ display: 'flex', flexDirection: 'column', width: '100%', flex: 1, minHeight: 0, margin: 0, padding: 0, overflow: 'hidden' }}>
            {url_cargar != "" &&
                <div style={{ width: '100%', flex: 1, minHeight: 0 }}>
                    <iframe src={url_cargar} style={{ width: '100%', height: '100vh', border: 'none', display: 'block' }} />
                </div>
            }
        </section>
    );
}

export default BeseifTransaciones;